import(/* webpackMode: "eager" */ "/opt/build/repo/packages/ecommdev/frontend/app/global-error.tsx");
